import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getMates = createAsyncThunk("mates/getMates", async () => {
  const response = await axios
    .get("http://localhost:8000/api/mates/")
    .catch((err) => {
      return err.data;
    });
  return response.data;
});

const initialState = {
  mates: [],
};

const matesSlice = createSlice({
  name: "mates",
  initialState,
  reducers: {},
  extraReducers: {
    [getMates.pending]: () => {
      console.log("Trayendo los mates");
    },
    [getMates.fulfilled]: (state, action) => {
      console.log("los datos: ", action.payload);
      return { mates: action.payload };
    },
  },
});
export default matesSlice.reducer;

export const allMates = (state) => state.mates.mates;
